import { createFileRoute } from "@tanstack/react-router";

import Dashboard from "@/components/[routes]/dashboard/dashboard";

export const Route = createFileRoute("/_secure/")({
  component: Dashboard,
});
